<template>
  <div class="RMPE-MessageError">
    <div v-if="!fieldHasError">
      <div class="help is-danger RMPE-MessageError-Placeholder">
        placeholder
      </div>
    </div>
    <div
      v-for="error in errors"
      :key="error.type"
    >
      <div
        v-if="!error.status && isBlurred"
        class="help is-danger"
        :class="classes"
      >
        {{ error.message }}
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    errors: {
      type: Array,
      default() {
        return [];
      },
    },
    isBlurred: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: String,
      default: '',
    },
    fieldHasError: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style scoped lang="scss">
.help.is-danger {
  background-color: #f14668;
  color: #FFF;
  padding: 5px;
  border-radius: 3px;
}
.RMPE-MessageError-Placeholder {
  opacity: 0;
}
</style>
